import React from "react";

export default function Trademark() {
    return <span className="align-super text-xs">®</span>;
}
